module.exports = __webpack_public_path__ + "img/城市估价@2x.5a7b0fda.png";